import { IBaseIconProps } from "./IBaseIconProps";

export const TwoCheckmarksDeliveredIcon = ({
  color = "#000",
  backgroundColor,
}: IBaseIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 14L5.23309 16.4248C5.66178 16.7463 6.26772 16.6728 6.60705 16.2581L15 6"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.95117 15.3293L11.8529 16.8507C12.5375 17.3984 13.5355 17.2931 14.0907 16.6145L22.4644 6.37999C22.6742 6.12352 22.6364 5.7455 22.38 5.53567C22.1235 5.32583 21.7455 5.36363 21.5356 5.6201L13.162 15.8546C13.0231 16.0243 12.7737 16.0506 12.6025 15.9137L10.7111 14.4005L9.95117 15.3293Z"
        fill={color}
        fillOpacity="0.25"
      />
    </svg>
  );
};
